import { render } from "./Pixels.vue?vue&type=template&id=7c4779e9"
import script from "./Pixels.vue?vue&type=script&lang=js"
export * from "./Pixels.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__